import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
var Pager = function Pager(props, _ref) {
  var $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $onUpdated = _ref.$onUpdated,
    $emit = _ref.$emit,
    $ref = _ref.$ref;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  $onUpdated(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var goTo = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(pageNumber) {
      var params;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            params = {
              page: pageNumber,
              rows: props.rowsPerPage
            };
            $emit('myEvent', params);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function goTo(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="data-table-footer">
  <div class="data-table-rows-select">
    
  </div>
  <div class="data-table-pagination">
    <span class="data-table-pagination-label">Page: ${props.params.currentPage}/${props.params.totalPages} Total Records: ${props.params.totalRecords}</span>
    <a href="#" class="link ${props.params.currentPage < 2 && $h`disabled`}" @click="${() => goTo(parseInt(props.params.currentPage)-1)}">
      <i class="icon icon-prev color-gray"></i>
    </a>
    <a href="#" class="link ${props.params.currentPage == props.params.totalPages && $h`disabled`}" @click="${() => goTo(parseInt(props.params.currentPage)+1)}">
      <i class="icon icon-next color-gray"></i>
    </a>
  </div>
</div>
`
    }
    ;
};
export default Pager;